export default __webpack_public_path__ + "static/media/activeFlowerAmount.688ea07c.png";